import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import "../Style/AddEmployee.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Save, Image as ImageIcon, X } from "lucide-react";
import { BASE_URL } from "../Apis/apiConfig";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddBankDetails = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [formData, setFormData] = useState({
    accountHolderName: "",
    bankName: "",
    accountNumber: "",
    ifscCode: "",
    branchName: "",
    bankAddress: "",
  });

  const [errors, setErrors] = useState({});
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageError, setImageError] = useState("");
  const MAX_IMAGE_SIZE = 5 * 1024 * 1024;

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const validate = () => {
    const newErrors = {};
    if (!formData.accountHolderName) newErrors.accountHolderName = "Required";
    if (!formData.bankName) newErrors.bankName = "Required";
    if (!formData.accountNumber) newErrors.accountNumber = "Required";
    if (!formData.ifscCode) newErrors.ifscCode = "Required";
    if (!formData.branchName) newErrors.branchName = "Required";
    if (!formData.bankAddress) newErrors.bankAddress = "Required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    const allowed = ["image/jpeg", "image/png", "image/webp", "image/gif"];
    if (!allowed.includes(file.type)) {
      setImageError("Only JPG, PNG, WEBP or GIF allowed.");
      setImageFile(null);
      setImagePreview(null);
      return;
    }
    if (file.size > MAX_IMAGE_SIZE) {
      setImageError("File too large (max 5MB).");
      setImageFile(null);
      setImagePreview(null);
      return;
    }

    setImageError("");
    setImageFile(file);

    const reader = new FileReader();
    reader.onload = (ev) => setImagePreview(ev.target.result);
    reader.readAsDataURL(file);
  };

  const removeImage = () => {
    setImageFile(null);
    setImagePreview(null);
    setImageError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
   const societyName = localStorage.getItem("society")
    const payload = new FormData();
    payload.append("accountHolderName", formData.accountHolderName);
    payload.append("bankName", formData.bankName);
    payload.append("accountNumber", formData.accountNumber);
    payload.append("IFSCCode", formData.ifscCode.toUpperCase());
    payload.append("branchName", formData.branchName);
    payload.append("bankAddress", formData.bankAddress);
    payload.append("backAccount", formData.bankAddress);
    payload.append("societyName",societyName )

    if (imageFile) {
      payload.append("QRCodeUpload", imageFile);
    }

    try {
      const token = localStorage.getItem("token");
      await axios.post(`${BASE_URL}/back/add-back-details`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Bank details added successfully");
      navigate(-1);
    } catch (error) {
      console.error(error);
      toast.error("Failed to add bank details");
    }
  };

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />
      <ToastContainer position="bottom-right" autoClose={3000} />

      <div className="main-layout">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

        <main className="content-area">
          <SubHeader />

          <div className="premium-form-container">
            <div className="premium-card">
              <div className="card-header-premium">
                <div className="header-content">
                  <button className="btn-back-icon-premium" onClick={() => navigate(-1)}>
                    <ArrowLeft size={20} />
                  </button>
                  <div>
                    <h2 className="form-title" style={{ color: "#2563eb" }}>Add Bank Details</h2>
                    <p className="form-subtitle">Enter bank details for a service provider</p>
                  </div>
                </div>
              </div>

              <form onSubmit={handleSubmit} className="premium-form-body">
                <div className="form-grid-premium">
                  <div className="form-group-premium">
                    <label className="label-premium">
                      <span>Account Holder Name</span>
                      <span className="required">*</span>
                    </label>
                    <div className="input-wrapper-premium">
                      <input
                        type="text"
                        name="accountHolderName"
                        value={formData.accountHolderName}
                        onChange={handleChange}
                        className={`input-premium ${errors.accountHolderName ? "error" : ""}`}
                        placeholder="Enter account holder name"
                      />
                    </div>
                    {errors.accountHolderName && <span className="error-text">{errors.accountHolderName}</span>}
                  </div>

                  <div className="form-group-premium">
                    <label className="label-premium">
                      <span>Bank Name</span>
                      <span className="required">*</span>
                    </label>
                    <div className="input-wrapper-premium">
                      <input
                        type="text"
                        name="bankName"
                        value={formData.bankName}
                        onChange={handleChange}
                        className={`input-premium ${errors.bankName ? "error" : ""}`}
                        placeholder="Enter bank name"
                      />
                    </div>
                    {errors.bankName && <span className="error-text">{errors.bankName}</span>}
                  </div>

                  <div className="form-group-premium">
                    <label className="label-premium">
                      <span>Account Number</span>
                      <span className="required">*</span>
                    </label>
                    <div className="input-wrapper-premium">
                      <input
                        type="text"
                        name="accountNumber"
                        value={formData.accountNumber}
                        onChange={handleChange}
                        className={`input-premium ${errors.accountNumber ? "error" : ""}`}
                        placeholder="Enter account number"
                      />
                    </div>
                    {errors.accountNumber && <span className="error-text">{errors.accountNumber}</span>}
                  </div>

                  <div className="form-group-premium">
                    <label className="label-premium">
                      <span>Branch Name</span>
                      <span className="required">*</span>
                    </label>
                    <div className="input-wrapper-premium">
                      <input
                        type="text"
                        name="branchName"
                        value={formData.branchName}
                        onChange={handleChange}
                        className={`input-premium ${errors.branchName ? "error" : ""}`}
                        placeholder="Enter branch name"
                      />
                    </div>
                    {errors.branchName && <span className="error-text">{errors.branchName}</span>}
                  </div>

                  <div className="form-group-premium">
                    <label className="label-premium">
                      <span>Bank Address</span>
                      <span className="required">*</span>
                    </label>
                    <div className="input-wrapper-premium">
                      <input
                        type="text"
                        name="bankAddress"
                        value={formData.bankAddress}
                        onChange={handleChange}
                        className={`input-premium ${errors.bankAddress ? "error" : ""}`}
                        placeholder="Enter bank address"
                      />
                    </div>
                    {errors.bankAddress && <span className="error-text">{errors.bankAddress}</span>}
                  </div>

                  <div className="form-group-premium">
                    <label className="label-premium">
                      <span>IFSC Code</span>
                      <span className="required">*</span>
                    </label>
                    <div className="input-wrapper-premium">
                      <input
                        type="text"
                        name="ifscCode"
                        value={formData.ifscCode}
                        onChange={handleChange}
                        className={`input-premium ${errors.ifscCode ? "error" : ""}`}
                        placeholder="Enter IFSC code"
                      />
                    </div>
                    {errors.ifscCode && <span className="error-text">{errors.ifscCode}</span>}
                  </div>

                  <div className="form-group-premium full-width">
                    <label className="label-premium">
                      <ImageIcon size={16} />
                      <span>QR Code Upload</span>
                    </label>
                    <div className={`file-upload-premium ${imageError ? "error" : ""}`}>
                      <input
                        type="file"
                        id="qr-code"
                        accept="image/*"
                        onChange={handleFileChange}
                        className="hidden-file-input"
                      />
                      {!imagePreview ? (
                        <label htmlFor="qr-code" className="upload-placeholder">
                          <div className="upload-icon-circle">
                            <ImageIcon size={24} />
                          </div>
                          <span>Click to upload QR code</span>
                          <span className="upload-hint">JPG, PNG, WEBP (Max 5MB)</span>
                        </label>
                      ) : (
                        <div className="image-preview-area">
                          <img src={imagePreview} alt="Preview" className="preview-img" />
                          <div className="preview-info">
                            <span className="file-name">{imageFile?.name}</span>
                            <button type="button" onClick={removeImage} className="btn-remove-image">
                              <X size={14} /> Remove
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                    {imageError && <span className="error-text">{imageError}</span>}
                  </div>
                </div>

                <div className="form-actions-premium">
                  <button type="button" className="btn-secondary-premium" onClick={() => navigate(-1)}>
                    Cancel
                  </button>
                  <button type="submit" className="btn-primary-premium">
                    <Save size={18} />
                    <span>Save Bank Details</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AddBankDetails;
